import React, { useEffect } from 'react';
import './MeetOurTeam.scss'
import '../../../pages/styles.scss';
import tagSvg from '../../../../assets/images/WhoWeHelp/tag.svg';
import CommonInsuranceSection from '../../../../components/reusable/HomePageSections/CommonInsuranceSection/CommonInsuranceSection.js';
import FooterSection from '../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { Link } from 'react-router-dom';
import { teamMembers } from '../../../../components/reusable/Common/Constant.js';

const MeetOurTeam = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='meet-our-team-container container'>
            <div className='meet-our-team-section section-1'>
                <div className='meet-our-team-section-content text'>
                    <h1>Meet Our Team</h1>
                    <p>At Virginia Rehab Physicians, we are dedicated to transforming healthcare for aging individuals and strive to redefine what it means to age with independence and quality of life. Get to know the skilled professionals who drive our services and programs.</p>
                    <div className='button-section'>
                        <a className='btn' href="/careers-and-culture">
                            <i className='bx bx-plus'></i>
                            Explore Job Opportunities
                        </a>
                    </div>
                </div>
            </div>
            <div className='meet-our-team-section section-2'>
                <div className='meet-our-team-section-content text'>
                    <div className='tag' style={{
                        backgroundImage: `url(${tagSvg})`,
                    }}>
                        <span>Team</span>
                    </div>
                    <h1>Skilled, Professional, and Committed to Excellence</h1>
                    <p>Our team brings a diverse range of expertise and dedication to the work we do. Discover more about the individuals who contribute to making our exceptional services a reality.</p>
                </div>
            </div>
            <div className='meet-our-team-section section-3'>
                <div className='meet-our-team-section-content text'>
                    <div className='tag' style={{
                        backgroundImage: `url(${tagSvg})`,
                    }}>
                        <span>Our Founder</span>
                    </div>
                    <h1>Founder and Lead Physician</h1>
                    <p>With a passion for innovation and a vision for excellence, Dr. Jenkins established this company to redefine industry standards. Driven by a commitment to quality, he has built a dynamic team focused on delivering exceptional results and fostering a culture of collaboration and creativity. Under his leadership, the company continues to grow, inspiring progress and innovation every step of the way.</p>
                    <div className='button-section'>
                        <a className='btn-2' href="/founder">
                            <i className='bx bx-right-arrow-alt' />
                            Show All
                        </a>
                    </div>
                </div>
                <div className='meet-our-team-section-content image'>
                    <div className='image-container'>
                        <img src={teamMembers.randy.image} alt="" />
                    </div>
                    <span>Randolph Jenkins, MD</span>
                    <div className='button-section'>
                        <Link
                            className='btn-2'
                            to="/team-member-details"
                            state={{
                                image: teamMembers.randy.image,
                                pageType: teamMembers.randy.pageType,
                                name: teamMembers.randy.name,
                                designation: teamMembers.randy.designation,
                                message: teamMembers.randy.message,
                            }}
                        >
                            <i className='bx bx-right-arrow-alt' />
                            Read More
                        </Link>
                    </div>
                </div>
            </div>
            <div className='meet-our-team-section section-4'>
                <div className='meet-our-team-section-content image'>
                    <div className='image-container'>
                        <img src={teamMembers.jake.image} alt="" />
                    </div>
                    <span>Jake Leonard, MBA</span>
                    <div className='button-section'>
                        <Link
                            className='btn-2'
                            to="/team-member-details"
                            state={{
                                image: teamMembers.jake.image,
                                pageType: teamMembers.jake.pageType,
                                name: teamMembers.jake.name,
                                designation: teamMembers.jake.designation,
                                message: teamMembers.jake.message,
                            }}
                        >
                            <i className='bx bx-right-arrow-alt' />
                            Read More
                        </Link>
                    </div>
                </div>
                <div className='meet-our-team-section-content text'>
                    <h1>Business Strategy & Ops</h1>
                    <p>Jake leads the charge in steering the company’s long-term vision, growth strategies, and day-to-day operations. With a keen eye for identifying opportunities and a deep understanding of market trends, he ensures the company remains agile and competitive.</p>
                    <div className='button-section'>
                        <a className='btn-2' href="/business-strategic-ops">
                            <i className='bx bx-right-arrow-alt' />
                            Show All
                        </a>
                    </div>
                </div>
            </div>
            <div className='meet-our-team-section section-5'>
                <div className='wrapper'>
                    <div className='meet-our-team-section-content text'>
                        <h1>Clinical</h1>
                        <p>
                            We deliver proactive, preventive and personalized care models to elderly patients living with or at risk for functional and cognitive impairments.
                        </p>
                        <br />
                        <p>
                            Our mission is to preserve and improve our patients’ independence, so they have the highest quality of life possible.
                        </p>
                        <div className='button-section'>
                            <a className='btn-2' href="/clinical-team">
                                <i className='bx bx-right-arrow-alt' />
                                Show All
                            </a>
                        </div>
                    </div>
                    <div className='meet-our-team-section-content image'>
                        <div className='image-container image-1'>
                            <div className='image-container'>
                                <img src={teamMembers.timothy.image} alt="" />
                            </div>
                            <p className='image-1-name'>{teamMembers.timothy.name}</p>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.timothy.image,
                                        pageType: teamMembers.timothy.pageType,
                                        name: teamMembers.timothy.name,
                                        designation: teamMembers.timothy.designation,
                                        message: teamMembers.timothy.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                        <div className='image-container image-2'>
                            <div className='image-container'>
                                <img src={teamMembers.aaron.image} alt="" />
                            </div>
                            <p className='image-2-name'>{teamMembers.aaron.name}</p>
                            <div className='button-section'>
                                <Link
                                    className='btn-2'
                                    to="/team-member-details"
                                    state={{
                                        image: teamMembers.aaron.image,
                                        pageType: teamMembers.aaron.pageType,
                                        name: teamMembers.aaron.name,
                                        designation: teamMembers.aaron.designation,
                                        message: teamMembers.aaron.message,
                                    }}
                                >
                                    <i className='bx bx-right-arrow-alt' />
                                    Read More
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='meet-our-team-section section-6'>
                <div className='meet-our-team-section-content image'>
                    <div className='image-1'>
                        <div className='image-container'>
                            <img src={teamMembers.farhan.image} alt="" />
                        </div>
                        <p className='image-1-name'>{teamMembers.farhan.name}</p>
                        <div className='button-section'>
                            <Link
                                className='btn-2'
                                to="/team-member-details"
                                state={{
                                    image: teamMembers.farhan.image,
                                    pageType: teamMembers.farhan.pageType,
                                    name: teamMembers.farhan.name,
                                    designation: teamMembers.farhan.designation,
                                    message: teamMembers.farhan.message,
                                }}
                            >
                                <i className='bx bx-right-arrow-alt' />
                                Read More
                            </Link>
                        </div>
                    </div>
                    <div className='image-2'>
                        <div className='image-container'>
                            <img src={teamMembers.yogi.image} alt="" />
                        </div>
                        <p className='image-1-name'>{teamMembers.yogi.name}</p>
                        <div className='button-section'>
                            <Link
                                className='btn-2'
                                to="/team-member-details"
                                state={{
                                    image: teamMembers.yogi.image,
                                    pageType: teamMembers.yogi.pageType,
                                    name: teamMembers.yogi.name,
                                    designation: teamMembers.yogi.designation,
                                    message: teamMembers.yogi.message,
                                }}
                            >
                                <i className='bx bx-right-arrow-alt' />
                                Read More
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='meet-our-team-section-content text'>
                    <h1>Engineering, IT & Product</h1>
                    <p>
                        We build, release and maintain all the technology and systems that support our clinicians, support staff, community partners and most importantly, patients. If no technology exists to solve a problem that faces the company, we invent it.
                    </p>
                    <div className='button-section'>
                        <a className='btn-2' href="/engineer-team">
                            <i className='bx bx-right-arrow-alt' />
                            Show All
                        </a>
                    </div>
                </div>
            </div>
            <CommonInsuranceSection />
            <FooterSection />
        </div >
    )
}

export default MeetOurTeam
